import React, { useEffect, useRef, useState } from 'react'
import { ROUTES } from '../../config/routingUrl';
import { fetchVehicleById, fetchVehiclesAllResearchAvailable } from '../../actions/request/VehicleRequest';
import { fetchPropertyById, fetchPropertysAllResearchAvailable } from '../../actions/request/PropertyRequest';
import { fetchReservationTypesAll } from '../../actions/request/ReservationTypeRequest';
import { fetchCustomersAll } from '../../actions/request/CustomerRequest';
import { fetchCodePostalsAll } from '../../actions/request/CodePostalRequest';
import axios from 'axios';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Accordion, Card, Col, Row, Button, Image, Spinner } from 'react-bootstrap';
import { baseurl, checkWordInURL } from '../../utils/url/baseurl';
import { toast } from 'react-toastify';
import { handleImageUploadCloud } from '../../actions/upload/UploadFileCloud';
import { ageDateNaissanceMax, currentDate, emptyImage, logoApplication, maxLengthLitte, maxLengthLong, Vector_Design } from '../../utils/dataApi/dataFormApi';
import Select from "react-select";
import { MdArrowCircleRight, MdClose, MdColorLens, MdColorize, MdDownload, MdMap, MdOutlineAirlineSeatReclineNormal, MdOutlineLocationOn, MdSend } from 'react-icons/md';
import moment from 'moment';
import { dureeDeVie, getAndCheckLocalStorage, setWithExpiration } from '../../utils/storage/localvalueFuction';
import { localStorageData, localStorageKeys } from '../../utils/storage/localvalue';
import { getDataFromFile, saveDataToFile } from '../../actions/DataLocal';
import { fetchCompanyAiportsAll } from '../../actions/request/CompanyAiportRequest';
import { handleDownloadImage } from '../../actions/upload/DowloadFileElement';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaChargingStation, FaMapMarkedAlt, FaSun, FaTachometerAlt } from 'react-icons/fa';
import { IoSpeedometerOutline } from 'react-icons/io5';
import { TbManualGearbox } from 'react-icons/tb';
import { BsCalendar } from "react-icons/bs";
import { SiTurbosquid } from "react-icons/si";
import { FETCH_PROPERTY_SUCCESS, FETCH_VEHICLE_SUCCESS } from '../../app/actions/actions';
import Carousel from 'react-multi-carousel';

const ReservationFormPage = () => {

  const location = useLocation();
  const params = useParams();  // Récupère les paramètres d'URL
  const { _id, name, brand, owner, basePricePerDay, images } = location.state;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const companyairports = useSelector((state) => state.companyairports.companyairports)
  const vehicle = useSelector((state) => state.vehicles.vehicle);
  const property = useSelector((state) => state.propertys.property);
  const reservationTypes = useSelector((state) => state.reservationTypes.reservationTypes);
  const customers = useSelector((state) => state.customers.customers);
  const codepostals = useSelector((state) => state.codepostals.codepostals);
  const vehicles = useSelector((state) => state.vehicles.vehiclesAvailable);
  const propertys = useSelector((state) => state.propertys.propertysAvailable);


  const [selectedType, setSelectedType] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [startHour, setStartHour] = useState({ value: '10:00', label: '10:00' });
  const [endDate, setEndDate] = useState({ value: '10:00', label: '10:00' });
  const [endHour, setEndHour] = useState({ value: '10:00', label: '10:00' });
  const [specialRequests, setSpecialRequests] = useState('');
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [codePostal, setCodePostal] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");


  // infos more
  const [idCard, setidCard] = useState("");
  const [idCardFile, setidCardFile] = useState([]);
  // Livret de famille
  const [driverLicenseNumber, setdriverLicenseNumber] = useState("");
  const [driverLicenseFile, setdriverLicenseFile] = useState([]);

  // Permis de conduire
  const [permisLicenseNumber, setpermisLicenseNumber] = useState("");
  const [permisLicenseFile, setpermisLicenseFile] = useState([]);

  const [dateOfBirth, setdateOfBirth] = useState("");

  const [latStart, setlatStart] = useState(null);
  const [lngStart, setlngStart] = useState(null);

  const [latEnd, setlatEnd] = useState(null);
  const [lngEnd, setlngEnd] = useState(null);

  const [companyAirport, setcompanyAirport] = useState();
  const [numberVolAiport, setnumberVolAiport] = useState();


  const [isPolicyAndCondidentiality, setisPolicyAndCondidentiality] = useState(false);
  const [isVerifyPolicyOfAgence, setisVerifyPolicyOfAgence] = useState(false)

  // companyAirport:companyAirport , 
  // numberVolAiport : numberVolAiport



  const [isLoading, setisLoading] = useState(false);


  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1200 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1200, min: 992 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 992, min: 768 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
    },
  };




  const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    setStartDate(newStartDate);
    if (endDate) {
      const start = new Date(newStartDate);
      const end = new Date(endDate);
      if (start > end) {
        setEndDate('');
        toast.error("La date de fin est inférieure à la date de début", { position: "bottom-right" });
      }
    }
  };

  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    setEndDate(newEndDate);
    if (startDate) {
      const start = new Date(startDate);
      const end = new Date(newEndDate);
      if (end < start) {
        setStartDate('');
        toast.info("La date de début est supérieure à la date de fin", { position: "bottom-right" });
      }
    }
    const currentDate = new Date();
    if (new Date(newEndDate) < currentDate) {
      setStartDate('');
      setEndDate('');
      toast.info("La date de fin est dans le passé", { position: "bottom-right" });
    }
  };

  const handleFileDriverFile = async (e) => {
    const newDriverLicenseFileUrls = await handleImageUploadCloud(e.target.files, toast) || [];
    setdriverLicenseFile((prevFiles) => {
      const updatedFiles = [...(prevFiles || []), ...newDriverLicenseFileUrls];
      if (updatedFiles.length > 10) {
        toast.error("Vous ne pouvez pas télécharger plus de 10 fichiers.", { position: "bottom-right" });
        return prevFiles; // Conserver les anciens fichiers sans ajouter les nouveaux
      }
      return updatedFiles.slice(-10); // Garder uniquement les 10 derniers éléments
    });
  };

  const handleFileIdCardFile = async (e) => {
    const newIdCardFileUrls = await handleImageUploadCloud(e.target.files, toast) || [];
    setidCardFile((prevFiles) => {
      const updatedFiles = [...(prevFiles || []), ...newIdCardFileUrls];
      if (updatedFiles.length > 10) {
        toast.error("Vous ne pouvez pas télécharger plus de 10 fichiers.", { position: "bottom-right" });
        return prevFiles; // Conserver les anciens fichiers sans ajouter les nouveaux
      }
      return updatedFiles.slice(-10); // Garder uniquement les 10 derniers éléments
    });
  };

  const handleFilePermisLicenseFile = async (e) => {
    const newPermisLicenseFileUrls = await handleImageUploadCloud(e.target.files, toast) || [];
    setpermisLicenseFile((prevFiles) => {
      const updatedFiles = [...(prevFiles || []), ...newPermisLicenseFileUrls];
      if (updatedFiles.length > 10) {
        toast.error("Vous ne pouvez pas télécharger plus de 10 fichiers.", { position: "bottom-right" });
        return prevFiles; // Conserver les anciens fichiers sans ajouter les nouveaux
      }
      return updatedFiles.slice(-10); // Garder uniquement les 10 derniers éléments
    });
  };



  const [activeKey, setActiveKey] = useState(null); // État pour gérer la section active

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key); // Active ou désactive la section
  };


  const section1Ref = useRef(null);

  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  };


  const [locationStart, setlocationStart] = useState('');
  const [locationEnd, setlocationEnd] = useState('');


  const [pickupLocation, setPickupLocation] = useState('');
  const [returnLocation, setReturnLocation] = useState('');
  const [pickupSuggestions, setPickupSuggestions] = useState([]);
  const [returnSuggestions, setReturnSuggestions] = useState([]);

  // Obtenir les suggestions de lieu de départ
  const getPlacesByCountryStartLocation = async (query) => {
    try {
      const response = await axios.get(`${baseurl.url}/api/v1/places`, {
        params: { query: query },
      });
      const places = response.data.results;
      return places.map(place => place);
    } catch (error) {
      console.error("Erreur lors de la récupération des lieux : ", error);
    }
  };

  // Obtenir les suggestions de lieu de retour
  const getPlacesByCountryEndLocation = async (query) => {
    try {
      const response = await axios.get(`${baseurl.url}/api/v1/places`, {
        params: { query: query },
      });
      const places = response.data.results;
      return places.map(place => place);
    } catch (error) {
      console.error("Erreur lors de la récupération des lieux : ", error);
    }
  };

  const handlePickupLocationChange = async (e) => {
    const value = e.target.value;
    setlocationStart(value);
    if (value.length > 2) {
      const suggestions = await getPlacesByCountryStartLocation(value);
      setPickupSuggestions(suggestions);
    } else {
      setPickupSuggestions([]); // Réinitialiser la liste des suggestions
    }
  };

  const handleReturnLocationChange = async (e) => {
    const value = e.target.value;
    setlocationEnd(value);
    if (value.length > 2) {
      const suggestions = await getPlacesByCountryEndLocation(value);
      setReturnSuggestions(suggestions);
    } else {
      setReturnSuggestions([]);
    }
  };

  const handlePickupSelection = (suggestion) => {

    setlocationStart(`${suggestion.name} - ${suggestion.formatted_address}`);
    setPickupLocation(`${suggestion.name} - ${suggestion.formatted_address}`);
    setlatStart(suggestion?.geometry?.location?.lat,);
    setlngStart(suggestion?.geometry?.location?.lng);

    // valeur locale en faite
    setWithExpiration(localStorageKeys.agenceDepArt, `${suggestion.name} - ${suggestion.formatted_address}`, dureeDeVie);
    setWithExpiration(localStorageKeys.latSelect, suggestion?.geometry?.location?.lat, dureeDeVie);
    setWithExpiration(localStorageKeys.longSelect, suggestion?.geometry?.location?.lng, dureeDeVie);

    // Met à jour newVehicle en une seule fois avec toutes les nouvelles valeurs

    // console.log({
    //   address: `${suggestion.name} - ${suggestion.formatted_address}`,
    //   lat: suggestion?.geometry?.location?.lat,
    //   lng: suggestion?.geometry?.location?.lng
    // });


    setPickupSuggestions([]);

    // Vérifier si le lieu de départ est identique au lieu de retour
    if (returnLocation && returnLocation === suggestion) {
      setPickupLocation('');
      setReturnLocation('');
      toast.error("Le lieu de départ et le lieu de retour ne peuvent pas être identiques.", { position: "bottom-right" });
    }
  };

  const handleReturnSelection = (suggestion) => {
    setlocationEnd(`${suggestion.name} - ${suggestion.formatted_address}`)
    setReturnLocation(`${suggestion.name} - ${suggestion.formatted_address}`);
    setlatEnd(suggestion?.geometry?.location?.lat,)
    setlngEnd(suggestion?.geometry?.location?.lng);


    setWithExpiration(localStorageKeys.agenceRetour, `${suggestion.name} - ${suggestion.formatted_address}`, dureeDeVie);

    setWithExpiration(localStorageKeys.latSelectRetour, suggestion?.geometry?.location?.lat, dureeDeVie);
    setWithExpiration(localStorageKeys.longSelectRetour, suggestion?.geometry?.location?.lng, dureeDeVie);



    // Met à jour newVehicle en une seule fois avec toutes les nouvelles valeurs
    // console.log({
    //   address: `${suggestion.name} - ${suggestion.formatted_address}`,
    //   lat: suggestion?.geometry?.location?.lat,
    //   lng: suggestion?.geometry?.location?.lng
    // })
    setReturnSuggestions([]);

    // Vérifier si le lieu de retour est identique au lieu de départ
    if (pickupLocation && pickupLocation === suggestion) {
      setPickupLocation('');
      setReturnLocation('');
      toast.error("Le lieu de départ et le lieu de retour ne peuvent pas être identiques.", { position: "bottom-right" });
    }
  };



  const handleCleanSugestions = () => {
    setPickupSuggestions([]);
    setReturnSuggestions([]);
  }







  useEffect(() => {

    // console.log(location.state)

    // valuer local à jour
    setStartDate(getAndCheckLocalStorage(localStorageKeys.dateDepart));
    setEndDate(getAndCheckLocalStorage(localStorageKeys.dateRetour));

    setStartHour(getDataFromFile(localStorageData.heureDepart) || { value: "10:00", label: "10:00" });
    setEndHour(getDataFromFile(localStorageData.heureRetour) || { value: "10:00", label: "10:00" });

    // information personnal
    setFirstname(getAndCheckLocalStorage(localStorageKeys.firstNameReservaiton));
    setLastname(getAndCheckLocalStorage(localStorageKeys.lastNameReservation));
    setEmail(getAndCheckLocalStorage(localStorageKeys.emailReservation));
    setPhone(getAndCheckLocalStorage(localStorageKeys.phoneReservation));
    setidCard(getAndCheckLocalStorage(localStorageKeys.idCardReservation));
    setpermisLicenseNumber(getAndCheckLocalStorage(localStorageKeys.permisLicenseNumberReservation));
    setdriverLicenseNumber(getAndCheckLocalStorage(localStorageKeys.driverLicenseNumberReservation));
    setdateOfBirth(getAndCheckLocalStorage(localStorageKeys.dateBirthDayreservation));
    setCodePostal(getDataFromFile(localStorageData.codePostalReservation) || null);

    // information address localisation
    setPickupLocation(getAndCheckLocalStorage(localStorageKeys.agenceDepArt));
    setlocationStart(getAndCheckLocalStorage(localStorageKeys.agenceDepArt))
    setlatStart(getAndCheckLocalStorage(localStorageKeys.latSelect));
    setlngStart(getAndCheckLocalStorage(localStorageKeys.longSelect));

    setReturnLocation(getAndCheckLocalStorage(localStorageKeys.agenceRetour));
    setlocationEnd(getAndCheckLocalStorage(localStorageKeys.agenceRetour));
    setlatEnd(getAndCheckLocalStorage(localStorageKeys.latSelectRetour));
    setlngEnd(getAndCheckLocalStorage(localStorageKeys.longSelectRetour));

    // information date
    setStartDate(getAndCheckLocalStorage(localStorageKeys.dateDepart));
    setEndDate(getAndCheckLocalStorage(localStorageKeys.dateRetour));

    setStartHour(getDataFromFile(localStorageData.heureDepart) || null);
    setEndHour(getDataFromFile(localStorageData.heureRetour) || null);

    // dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: {} })
    // dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: {} })
    dispatch(fetchVehicleById(_id || ""));
    dispatch(fetchPropertyById(_id || ""));
    dispatch(fetchReservationTypesAll());
    dispatch(fetchCustomersAll());
    dispatch(fetchCodePostalsAll());
    dispatch(fetchCompanyAiportsAll());

    dispatch(fetchVehiclesAllResearchAvailable(currentDate, currentDate));
    dispatch(fetchPropertysAllResearchAvailable(currentDate, currentDate));

  }, [dispatch, _id]);



  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  // État pour gérer le survol de chaque élément
  const [hoverStates, setHoverStates] = useState({});

  // Fonction pour mettre à jour l'état de survol d'un élément spécifique
  const handleMouseEnter = (id) => {
    setHoverStates((prevState) => ({
      ...prevState,
      [id]: true,
    }));
  };

  const handleMouseLeave = (id) => {
    setHoverStates((prevState) => ({
      ...prevState,
      [id]: false,
    }));
  };


  useEffect(() => {
    // Filtrage basé sur le prix
    const vehiclesFiltered = vehicles || []
    const propertiesFiltered = propertys || []
    setFilteredVehicles(vehiclesFiltered);
    setFilteredProperties(propertiesFiltered);
  }, [vehicles, propertys]);



  const currentItems = (vehicle && vehicle._id)
    ? filteredVehicles
    : filteredProperties;



  // const images = vehicle && vehicle.images ? vehicle.images.map((image) => ({
  //   original: image,
  //   thumbnail: image,
  // })) : property && property.images ? property.images.map((image) => ({
  //   original: image,
  //   thumbnail: image,
  // })) : [];

  const companyAirportOptions = companyairports && companyairports.length > 0 ? companyairports.map((type) => ({
    value: type._id,
    label: type.name,
  })) : [];


  const typeOptions = reservationTypes && reservationTypes.length > 0 ? reservationTypes.map((type) => ({
    value: type._id,
    label: type.name,
  })) : [];

  const clientOptions = customers && customers.length > 0 ? customers.map((client) => ({
    value: client._id,
    label: `${client.firstname} ${client.lastname}`,
  })) : [];



  const indicatifOptions = codepostals && codepostals.length > 0 ? codepostals.map((client) => ({
    value: client._id,
    label: `+${client.indicatif} ${client.country}`,
  })) : [];



  // Calculate the maximum date (16 years ago) using Moment.js
  const maxDate = moment().subtract(ageDateNaissanceMax, 'years').format('YYYY-MM-DD');



  // Options d'heures (par intervalles de 30 minutes)
  const hourOptions = Array.from({ length: 24 }, (_, i) => {
    const hour = i.toString().padStart(2, '0');
    return [
      { value: `${hour}:00`, label: `${hour}:00` },
      { value: `${hour}:30`, label: `${hour}:30` }
    ];
  }).flat();

  // Combiner la date et l'heure pour obtenir une date complète au format ISO
  const combineDateAndTime = (date, time) => {
    const [hours, minutes] = time.value.split(':');
    const combined = new Date(date);
    combined.setHours(hours);
    combined.setMinutes(minutes);
    combined.setSeconds(0);
    combined.setMilliseconds(0);
    return combined.toISOString(); // Convertir en format ISO 8601
  };

  const newMinDate = moment(startDate).add(1, 'days').format('YYYY-MM-DD');



  const [verifyReservation, setverifyReservation] = useState(false);
  const checkAvailabilityReservationAndMaintenanceSubmit = async (startDate, endDate, propertyId, vehicleId, userAdd) => {
    setisLoading(true);
    setverifyReservation(false);

    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (propertyId) params.append("propertyId", propertyId);
    if (vehicleId) params.append("vehicleId", vehicleId);
    if (userAdd) params.append("userAdd", userAdd);

    try {
      const response = await axios.get(`${baseurl.url}/api/v1/reservations/check-availability?${params.toString()}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
        }
      });

      setverifyReservation(response.data.success);
      setisLoading(false);
      return response.data.success;  // ✅ Retourne la vraie valeur de l'API
    } catch (error) {
      console.error("🚨 Erreur API Vérification Disponibilité :", error);

      setverifyReservation(false);
      toast.error(error?.response?.data?.message || "Vérification de la disponibilité échouée. Veuillez réessayer.");

      setisLoading(false);
      return false;  // ✅ Toujours retourner `false` en cas d'erreur
    }
  };

  const submitReservation = async (e) => {
    e.preventDefault();
    setisLoading(true);

    try {
      // Vérification des dates et heures de début et de fin
      if (!startDate || !endDate || !startHour || !endHour) {
        toast.error("Veuillez sélectionner les dates et heures de début et de fin.", { position: "bottom-right" });
        setisLoading(false);
        return;
      }

      // Combinaison des dates et heures
      const startDateTime = combineDateAndTime(startDate, startHour);
      const endDateTime = combineDateAndTime(endDate, endHour);

      // Validation de véhicule ou propriété sélectionné(e)
      if (!vehicle?._id && !property?._id) {
        toast.error("Veuillez sélectionner un véhicule ou une propriété.", { position: "bottom-right" });
        setisLoading(false);
        return;
      }

      // Validation des informations de contact de l'utilisateur
      if (!firstname || !lastname || !email || !phone || !codePostal?.value || !dateOfBirth) {
        toast.error("Veuillez remplir tous les champs de contact requis (prénom, nom, email, téléphone, code postal, date de naissance).", { position: "bottom-right" });
        setisLoading(false);
        return;
      }

      // Validation des documents d'identité
      if (!idCard && !driverLicenseNumber) {
        toast.error("Pièce d'identité ou permis de conduire obligatoire", { position: "bottom-right" });
        setisLoading(false);
        return;
      }

      // Vérification des coordonnées géographiques
      if (vehicle?._id && (!latStart || !lngStart || !latEnd || !lngEnd)) {
        toast.error("Veuillez vérifier les coordonnées géographiques de départ et d'arrivée.", { position: "bottom-right" });
        setisLoading(false);
        return;
      }

      if ((companyAirport && !numberVolAiport) ||
        (!companyAirport && numberVolAiport)) {
        toast.error("Veuillez fournir à la fois la compagnie aérienne et le numéro de vol.", { position: "bottom-right" });
        setisLoading(false);
        return;
      }

      if (!isPolicyAndCondidentiality) {
        toast.error("Veillez accepter les conditions d'utilisation de la plateforme", { position: "bottom-right" })
        setisLoading(false);
        return;
      }

      if (!isVerifyPolicyOfAgence) {
        toast.error("Veillez accepter les termes et politique de l'agence de réservation", { position: "bottom-right" })
        setisLoading(false);
        return;
      }

      // Vérification de disponibilité
      const isAvailable = await checkAvailabilityReservationAndMaintenanceSubmit(startDateTime, endDateTime, property?._id, vehicle?._id, vehicle?.addBy || property?.addBy);

      if (!isAvailable) {
        toast.error("Une réservation ou une maintenance existe déjà sur cette période. Veuillez choisir une autre date.");
        setisLoading(false);
        return;
      }

      if (vehicle?._id && (idCardFile.length === 0 && permisLicenseFile.length === 0)) {
        toast.error("Veuillez télécharger les fichiers requis (carte d'identité et permis de conduire)", { position: "bottom-right" });
        setisLoading(false);
        return;
      }

      // information personnal
      setWithExpiration(localStorageKeys.firstNameReservaiton, firstname, dureeDeVie);
      setWithExpiration(localStorageKeys.lastNameReservation, lastname, dureeDeVie);
      setWithExpiration(localStorageKeys.emailReservation, email, dureeDeVie);
      setWithExpiration(localStorageKeys.phoneReservation, phone, dureeDeVie);
      setWithExpiration(localStorageKeys.idCardReservation, idCard || "", dureeDeVie);
      setWithExpiration(localStorageKeys.driverLicenseNumberReservation, driverLicenseNumber || "", dureeDeVie);
      setWithExpiration(localStorageKeys.permisLicenseNumberReservation, permisLicenseNumber || "", dureeDeVie);
      setWithExpiration(localStorageKeys.dateBirthDayreservation, dateOfBirth, dureeDeVie);
      saveDataToFile(localStorageData.codePostalReservation, codePostal);

      // information address localisation
      setWithExpiration(localStorageKeys.agenceDepArt, pickupLocation, dureeDeVie);
      setWithExpiration(localStorageKeys.agenceRetour, returnLocation, dureeDeVie);

      setWithExpiration(localStorageKeys.latSelect, latStart, dureeDeVie);
      setWithExpiration(localStorageKeys.longSelect, lngStart, dureeDeVie);

      setWithExpiration(localStorageKeys.latSelectRetour, latEnd, dureeDeVie);
      setWithExpiration(localStorageKeys.longSelectRetour, lngEnd, dureeDeVie);

      // information date
      setWithExpiration(localStorageKeys.dateDepart, startDate, dureeDeVie);
      setWithExpiration(localStorageKeys.dateRetour, endDate, dureeDeVie);

      saveDataToFile(localStorageData.heureDepart, startHour);
      saveDataToFile(localStorageData.heureRetour, endHour);



      // Création de l'objet de réservation
      const reservationData = {
        reservationElement: vehicle?._id ? "Vehicle" : "Property",
        type: selectedType?.value,
        vehicle: vehicle?._id,
        property: property?._id,
        firstname,
        lastname,
        email,
        phone,
        codePostal: codePostal?.value,
        startDate: startDateTime,
        endDate: endDateTime,
        specialRequests,
        basePricePerDay: vehicle?.basePricePerDay || property?.basePricePerDay,
        commissionPercentage: vehicle?.commissionPercentage || property?.commissionPercentage,
        deliveryFee: vehicle?.deliveryFee || property?.deliveryFee,
        image: images[0] || logoApplication,
        userAdd: vehicle?.addBy || property?.addBy,
        idCard,
        idCardFile: idCardFile,
        driverLicenseNumber,
        driverLicenseFile: driverLicenseFile,
        permisLicenseNumber: permisLicenseNumber,
        permisLicenseFile: permisLicenseFile,
        dateOfBirth,
        pickupLocation,
        returnLocation,
        latStart,
        lngStart,
        latEnd,
        lngEnd,
        companyAirport: companyAirport?.value || "",
        numberVolAiport: numberVolAiport
      };


      // Redirection avec les données de réservation
      const urlGet = checkWordInURL(ROUTES.DASHBOARD);
      navigate(urlGet ? `/${ROUTES.DASHBOARD}/${ROUTES.RESERVATIONS_INVOICE_WEB}` : `/${ROUTES.RESERVATIONS_INVOICE_WEB}`, { state: reservationData });
    } catch (error) {
      // console.log(error)
      toast.error("Une erreur s'est produite lors de la soumission de la réservation. Veuillez réessayer.", { position: "bottom-right" });
    } finally {
      setisLoading(false);
    }
  };









  // Empêcher la sélection de dates passées
  const today = new Date().toISOString().split('T')[0];


  // Etapes
  const [currentStep, setCurrentStep] = useState(1);
  // Données des étapes
  const steps = [
    { id: 1, title: "Étape 1 :", description: "Informations personnelles" },
    { id: 2, title: "Étape 2 :", description: "Informations administratives" },
    { id: 3, title: "Étape 3 :", description: "Informations supplémentaires" },
    { id: 4, title: "Étape 4 :", description: "Résumé et validation" },
  ];
  const handleStepClick = (stepId) => {
    setCurrentStep(stepId); // Mettre à jour l'étape active
  };



  // Fonction pour passer à l'étape suivante
  const handleNextStep = () => {
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
      console.log(permisLicenseFile);
    }
  };

  // Fonction pour revenir à l'étape précédente
  const handlePreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };








  return (
    <div className="container-fluid" style={{ padding: "100px 0px 0px 0px", background: "#F5FDF7" }} onClick={handleCleanSugestions}>




      <div className="container" style={{ position: "relative", zIndex: 65 }}>
        <div className="pb-5">
          <div>
            <Button className="" onClick={() => { navigate(-1) }} variant="dark" style={{ borderRadius: "20px", padding: "10px 10px 10px 10px" }}>
              <span className="bg-white rounded-lg"><FaArrowAltCircleLeft color={"#42B711"} size={30} /></span>  <span className="px-3"> Retour </span></Button>
          </div>
        </div>
        <div className="row">
          <Col md={6}>
            <div className="" style={{ height: '100%', }}>
              <div>
                {/* Galerie d'images */}

                {
                  vehicle &&
                  vehicle.images &&
                  vehicle.images && (
                    <div
                      style={{
                        height: "350px", // Hauteur fixe
                        width: "100%",
                        overflow: "hidden",
                        borderRadius: "15px", // Coins arrondis pour le conteneur
                      }}
                    >
                      <Image
                        src={vehicle.images[0] || emptyImage}
                        className="img-fluid rounded-md"
                        alt=""
                        style={{
                          height: "350px",
                          width: "100%",
                          objectFit: "fill",
                          borderRadius: "15px", // Coins arrondis pour l'image
                        }}
                      />
                    </div>
                  )
                }
                {
                  property &&
                  property.images &&
                  property.images && (
                    <div
                      style={{
                        height: "400px", // Hauteur fixe
                        width: "100%",
                        overflow: "hidden",
                        borderRadius: "15px", // Coins arrondis pour le conteneur
                      }}
                    >
                      <Image
                        src={property.images[0] || emptyImage}
                        className="img-fluid rounded-md"
                        alt=""
                        style={{
                          height: "450px",
                          width: "100%",
                          objectFit: "fill",
                          borderRadius: "15px", // Coins arrondis pour l'image
                        }}
                      />
                    </div>
                  )
                }


              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className=" rounded-5  m-b40 m-sm-b0">
              <div className="">
                <div>
                  <div className="dlab-post-title">
                    <h3 className="post-title">
                      <Link to="javascript:void(0);" style={{ fontSize: "32px", color: "black" }}>{brand || name}</Link>
                    </h3>
                    {/*<h6 className="sub-title">{vehicle?.type?.name || ""}</h6> */}
                    <div style={{ display: "flex", alignContent: "center" }}>
                      <span style={{ fontWeight: "bold", color: "black", fontSize: "32px" }} className="font-bold"> {basePricePerDay || 0} </span>
                      <span style={{ fontWeight: "bold", color: "black", fontSize: "32px" }} className="px-1"> DZD </span>
                      <span style={{ color: "#A6A6A6", fontSize: "20px", textAlign: "end" }} className="px-1 pt-2"> /Jour</span>
                    </div>
                  </div>

                  {/* ✅ Caractéristiques du véhicule */}

                </div>
              </div>
            </div>
          </Col>
          {/*options supplementaires */}
        </div>
      </div >








      <div className="container-fluid " style={{ position: "relative", zIndex: 60, top: -150, background: "linear-gradient(90deg, #43B613, #1D5008)", padding: "150px 10px 100px 10px" }}>
        <div className="container bg-transparent" style={{ position: "relative", zIndex: 70 }}>
          <div className="row">
            <Col md={9} >

              <Form onSubmit={submitReservation} style={{ background: "transparent", padding: "50px 5px 50px 5px" }} >


                {/*Etapes */}

                <Row className=" text-white pb-5 ">
                  {steps.map((step) => (
                    <Col
                      key={step.id}
                      className="d-flex align-items-center justify-content-center"
                      onClick={() => setCurrentStep(step.id)} // Mettre à jour l'étape active au clic
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        className="step-indicator"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {/* Numéro d'étape */}
                        <div>
                          <span
                            className={`px-2 py-1 ${currentStep === step.id ? "bg-success" : "bg-white"}`}
                            style={{
                              borderRadius: "50%",
                              color: currentStep === step.id ? "white" : "black",
                              fontSize: "14px",
                              fontWeight: "bold",
                            }}
                          >
                            {step.id}
                          </span>
                        </div>

                        {/* Titre et description de l'étape */}
                        <div className="px-2">
                          <span
                            className="text-sm"
                            style={{
                              fontSize: "14px",
                              fontWeight: currentStep === step.id ? "bold" : "normal",
                              color: currentStep === step.id ? "white" : "#ccc",
                            }}
                          >
                            {step.title}
                          </span>
                          <br />
                          <span
                            className="text-sm"
                            style={{
                              fontSize: "14px",
                              fontWeight: currentStep === step.id ? "bold" : "normal",
                              color: currentStep === step.id ? "white" : "#ccc",
                            }}
                          >
                            {step.description}
                          </span>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>

                <Row>
                  {currentStep == 1 && (
                    <>
                      <Col md={4}>
                        <Form.Group controlId="firstname">
                          <Form.Label className="text-white">Nom <span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="text"
                            value={firstname}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (inputValue.length <= maxLengthLitte) {
                                setFirstname(inputValue);
                              }
                            }}
                            style={{
                              height: '40px',
                              background: "#FFFFFF",
                              borderRadius: "20px", // Bordures arrondies
                              border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="lastname">
                          <Form.Label className="text-white">Prénoms <span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="text"
                            value={lastname}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (inputValue.length <= maxLengthLitte) {
                                setLastname(inputValue);
                              }
                            }}

                            style={{
                              height: '40px',
                              background: "#FFFFFF",
                              borderRadius: "20px", // Bordures arrondies
                              border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="email">
                          <Form.Label className="text-white">Email <span className="text-danger text-lg">*</span></Form.Label>
                          <Form.Control
                            type="email"
                            value={email}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (inputValue.length <= maxLengthLitte) {
                                setEmail(inputValue);
                              }
                            }}

                            style={{
                              height: '40px',
                              background: "#FFFFFF",
                              borderRadius: "20px", // Bordures arrondies
                              border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="codePostal">
                          <Form.Label className="text-white">Indicatif téléphone <span className="text-danger">*</span></Form.Label>
                          <Select
                            options={indicatifOptions}
                            value={codePostal}
                            onChange={setCodePostal}
                            placeholder=""
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                height: '40px',
                                background: "#FFFFFF",
                                borderRadius: "20px", // Bordures arrondies
                                border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                              })
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="phone">
                          <Form.Label className="text-white">Téléphone <span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="text"
                            value={phone}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (inputValue.length <= 20) {
                                setPhone(inputValue);
                              }
                            }}

                            style={{
                              height: '40px',
                              background: "#FFFFFF",
                              borderRadius: "20px", // Bordures arrondies
                              border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité

                            }}
                          />
                        </Form.Group>
                      </Col>




                      {/*Infomtion dur les les doucment nécessaire pour la reservaiton */}


                      <Col md={4}>
                        <Form.Group controlId="firstname">
                          <Form.Label className="text-white">Date de naissance <span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            max={maxDate}
                            type="date" className=""
                            value={dateOfBirth}
                            onChange={(e) => setdateOfBirth(e.target.value)}

                            style={{
                              height: '40px',
                              background: "#FFFFFF",
                              borderRadius: "20px", // Bordures arrondies
                              border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </>
                  )

                  }


                  {/*pièce d'identté ou passeport */}
                  {

                    currentStep == 2 && (
                      <>
                        <Col md={6}>
                          <Form.Group controlId="lastname">
                            <Form.Label className="text-white">N° Pièce d{"'"}identité / Passeport <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                              type="text"
                              value={idCard}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue.length <= maxLengthLitte) {
                                  setidCard(inputValue);
                                }
                              }}
                              style={{
                                height: '40px',
                                background: "#FFFFFF",
                                borderRadius: "20px", // Bordures arrondies
                                border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                              }}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group controlId="lastname">
                            <Form.Label className="text-white"> Carte d{"'"}identité / Passeport  ( Recto verso ) <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                              type="file" multiple accept="image/*" onChange={handleFileIdCardFile}

                              style={{
                                height: '40px',
                                background: "#FFFFFF",
                                borderRadius: "20px", // Bordures arrondies
                                border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité

                              }}
                            />
                          </Form.Group>
                          {idCardFile && idCardFile.length > 0 ?
                            <div>
                              <h6 className="text-white">Fichiers sélectionnées :</h6>
                              <ul
                                className='flex'
                                style={{ display: 'flex', flexWrap: 'wrap' }}
                              >
                                {idCardFile && idCardFile.length > 0 && idCardFile.map((image, index) => {
                                  return (
                                    <li key={index} className='p-1'>
                                      <div>
                                        <span
                                          className='text-danger text-xs'
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => {
                                            // On supprime l'image correspondant à l'index
                                            const updatedImages =
                                              idCardFile.filter(
                                                (_, i) => i !== index
                                              )
                                            setidCardFile(updatedImages)
                                          }}
                                        >
                                          <MdClose size={30} />
                                        </span>

                                        <span
                                          className='text-dark text-xs p-1'
                                          title="Télécharger"
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => {
                                            // On supprime l'image correspondant à l'index
                                            handleDownloadImage(image, `Pièce-d'identité-ou-passport-${index}`)
                                          }}
                                        >
                                          <MdDownload size={30} />
                                        </span>
                                      </div>
                                      <div>
                                        <img
                                          src={image}
                                          style={{ height: '60px', width: '60px' }}
                                        />
                                      </div>
                                    </li>
                                  )
                                }
                                )
                                }
                              </ul>
                            </div>
                            : ""
                          }
                        </Col>


                        {/*Permis  */}
                        {brand && (
                          <Col md={6}>
                            <Form.Group controlId="lastname">
                              <Form.Label className="text-white">N° du permis <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="text"
                                value={permisLicenseNumber}
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  if (inputValue.length <= maxLengthLitte) {
                                    setpermisLicenseNumber(inputValue);
                                  }
                                }}
                                style={{
                                  height: '40px',
                                  background: "#FFFFFF",
                                  borderRadius: "20px", // Bordures arrondies
                                  border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                                }}
                              />
                            </Form.Group>
                          </Col>
                        )}

                        {vehicle && vehicle?._id && (
                          <Col md={6}>
                            <Form.Group controlId="lastname">
                              <Form.Label className="text-white"> Permis de conduire  ( Recto Verso ) <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="file" multiple accept="image/*" onChange={handleFilePermisLicenseFile}
                                style={{
                                  height: '40px',
                                  background: "#FFFFFF",
                                  borderRadius: "20px", // Bordures arrondies
                                  border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                                }}
                              />
                            </Form.Group>
                            {permisLicenseFile && permisLicenseFile.length > 0 ? (
                              <div>
                                <h6 className="text-white">Fichiers sélectionnées :</h6>
                                <ul className="flex" style={{ display: "flex", flexWrap: "wrap" }}>
                                  {permisLicenseFile.map((image, index) => (
                                    <li key={index} className='p-1'>
                                      <div>
                                        <span
                                          className='text-danger text-xs'
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => {
                                            const updatedImages = permisLicenseFile.filter((_, i) => i !== index);
                                            setpermisLicenseFile(updatedImages);
                                          }}
                                        >
                                          <MdClose size={30} />
                                        </span>
                                        <span
                                          className='text-dark text-xs p-1'
                                          title="Télécharger"
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => handleDownloadImage(image, `Permis-de-conduire-${index}`)}
                                        >
                                          <MdDownload size={30} />
                                        </span>
                                      </div>
                                      <div>
                                        <img src={image} style={{ height: '60px', width: '60px' }} />
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            ) : null}
                          </Col>
                        )}

                        {/*<Col md={4}>
                    <Form.Group controlId="lastname">
                      <Form.Label>N° Passport / Permis  </Form.Label>
                      <Form.Control
                        type="text"
                        value={driverLicenseNumber}
                        onChange={(e) => setdriverLicenseNumber(e.target.value)}

                        style={{ height: '40px' }}
                      />
                    </Form.Group>
                  </Col> */}


                        {
                          property && property?._id && (
                            <Col md={12}>
                              <Form.Group controlId="lastname">
                                <Form.Label className="text-white"> Livret de famille  </Form.Label>
                                <Form.Control
                                  type="file" multiple accept="image/*" onChange={handleFileDriverFile}

                                  style={{
                                    height: '40px',
                                    background: "#FFFFFF",
                                    borderRadius: "20px", // Bordures arrondies
                                    border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                                  }}
                                />
                              </Form.Group>
                              {driverLicenseFile?.length > 0 && (
                                <div>
                                  <h6 className="text-white">Fichiers sélectionnées :</h6>
                                  <ul
                                    className='flex'
                                    style={{ display: 'flex', flexWrap: 'wrap' }}
                                  >
                                    {driverLicenseFile?.map((image, index) => (
                                      <li key={index} className='p-1'>
                                        <div>
                                          <span
                                            className='text-danger text-xs'
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                              // On supprime l'image correspondant à l'index
                                              const updatedImages =
                                                driverLicenseFile.filter(
                                                  (_, i) => i !== index
                                                )
                                              setdriverLicenseFile(updatedImages)
                                            }}
                                          >
                                            <MdClose size={30} />
                                          </span>

                                          <span
                                            className='text-dark text-xs p-1'
                                            title="Télécharger"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                              // On supprime l'image correspondant à l'index
                                              handleDownloadImage(image, `Livret-de-famille-${index}`)
                                            }}
                                          >
                                            <MdDownload size={30} />
                                          </span>
                                        </div>
                                        <div>
                                          <img
                                            src={image}
                                            style={{ height: '60px', width: '60px' }}
                                          />
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </Col>
                          )
                        }

                      </>
                    )
                  }

                  {
                    currentStep == 3 && (
                      <>
                        <Col md={3}>
                          <Form.Group controlId="startDate">
                            <Form.Label className="text-white">Date de début <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                              type="date" className="date-picker"
                              min={today}
                              value={startDate}
                              onChange={(e) => setStartDate(e.target.value)}

                              style={{
                                height: '40px',
                                background: "#FFFFFF",
                                borderRadius: "20px", // Bordures arrondies
                                border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                              }}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={3}>
                          <Form.Group controlId="startHour">
                            <Form.Label className="text-white">Heure de début <span className="text-danger">*</span></Form.Label>
                            <Select

                              value={startHour}
                              onChange={(selectedOption) => setStartHour(selectedOption)}
                              options={hourOptions}
                              styles={{
                                height: '40px',
                                background: "#FFFFFF",
                                borderRadius: "20px", // Bordures arrondies
                                border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                              }}
                            />
                          </Form.Group>
                        </Col>

                        {/* Date de fin et heure */}
                        <Col md={3}>
                          <Form.Group controlId="endDate">
                            <Form.Label className="text-white">Date de fin <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                              type="date" className="date-picker"
                              min={newMinDate || today}
                              value={endDate}
                              onChange={(e) => setEndDate(e.target.value)}

                              style={{
                                height: '40px',
                                background: "#FFFFFF",
                                borderRadius: "20px", // Bordures arrondies
                                border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                              }}
                              disabled={!startDate}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={3}>
                          <Form.Group controlId="endHour">
                            <Form.Label className="text-white">Heure de fin <span className="text-danger">*</span></Form.Label>
                            <Select

                              value={endHour}
                              onChange={(selectedOption) => setEndHour(selectedOption)}
                              options={hourOptions}
                              isDisabled={!startDate}
                              style={{
                                height: '40px',
                                background: "#FFFFFF",
                                borderRadius: "20px", // Bordures arrondies
                                border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                              }}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group controlId="endHour">
                            <Form.Label className="text-white">Compagnie Aérienne </Form.Label>
                            <div >
                              <Select
                                value={companyAirport}
                                onChange={(selectedOption) => setcompanyAirport(selectedOption)}
                                options={companyAirportOptions}
                                placeholder="Selectionnez"
                                isClearable
                                style={{
                                  height: '40px',
                                  background: "#FFFFFF",
                                  borderRadius: "20px", // Bordures arrondies
                                  border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                                }}
                              />
                            </div>
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group controlId="endDate">
                            <Form.Label className="text-white">Numéro de vol</Form.Label>
                            <Form.Control
                              type="text"
                              value={numberVolAiport}

                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue.length <= maxLengthLitte) {
                                  setnumberVolAiport(inputValue);
                                }
                              }}
                              style={{
                                height: '40px',
                                background: "#FFFFFF",
                                borderRadius: "20px", // Bordures arrondies
                                border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )
                  }



                  {/* Lieu de départ */}
                  {
                    currentStep == 4 && (
                      <>
                        {
                          vehicle && vehicle?._id && (
                            <Col md={6}>
                              <Form.Group controlId="pickupLocation">
                                <Form.Label className="text-white">Lieu de départ <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                  type="text"
                                  value={locationStart}
                                  onChange={handlePickupLocationChange}
                                  style={{
                                    height: '40px',
                                    background: "#FFFFFF",
                                    borderRadius: "20px", // Bordures arrondies
                                    border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                                  }}
                                  placeholder="Entrez un lieu en Algerie"
                                />
                                {/* Liste déroulante des suggestions */}
                                {pickupSuggestions && pickupSuggestions.length > 0 && (
                                  <ul className="rounded p-1 border" style={{ position: 'absolute', zIndex: 1000, backgroundColor: 'white', maxwidth: "400px", listStyleType: 'none', padding: 0, maxHeight: "200px", overflow: "auto" }}>
                                    {pickupSuggestions.map((suggestion, index) => (
                                      <li className="border"
                                        key={index}
                                        style={{ padding: '5px', cursor: 'pointer' }}
                                        onClick={() => handlePickupSelection(suggestion)}
                                      >
                                        {`${suggestion.name} - ${suggestion.formatted_address}`}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </Form.Group>
                            </Col>
                          )
                        }

                        {/* Lieu de retour */}
                        {
                          vehicle && vehicle?._id && (
                            <Col md={6}>
                              <Form.Group controlId="returnLocation">
                                <Form.Label className="text-white">Lieu de retour <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                  type="text"
                                  value={locationEnd}
                                  onChange={handleReturnLocationChange}
                                  style={{
                                    height: '40px',
                                    background: "#FFFFFF",
                                    borderRadius: "20px", // Bordures arrondies
                                    border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité

                                  }}
                                  placeholder="Entrez un lieu en Algerie"
                                />
                                {/* Liste déroulante des suggestions */}
                                {returnSuggestions && returnSuggestions.length > 0 && (
                                  <ul className="rounded p-1 border" style={{ position: 'absolute', zIndex: 1000, backgroundColor: 'white', maxWidth: "400px", listStyleType: 'none', padding: 0, maxHeight: "200px", overflow: "auto" }}>
                                    {returnSuggestions.map((suggestion, index) => (
                                      <li className="border"
                                        key={index}
                                        style={{ padding: '5px', cursor: 'pointer' }}
                                        onClick={() => handleReturnSelection(suggestion)}
                                      >
                                        {`${suggestion.name} - ${suggestion.formatted_address}`}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </Form.Group>
                            </Col>
                          )
                        }


                        <Col md={12}>
                          <Form.Group controlId="specialRequests">
                            <Form.Label className="text-white">Information suplémentaire</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={specialRequests}

                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue.length <= maxLengthLong) {
                                  setSpecialRequests(inputValue);
                                }
                              }}
                              style={{
                                height: '100px',
                                background: "#FFFFFF",
                                borderRadius: "20px", // Bordures arrondies
                                border: "1px solid #FFFFFF", // Bordure légère pour améliorer la visibilité
                              }}
                            />
                          </Form.Group>
                        </Col>


                        <hr className="mt-5 text-gray" />
                        {/* Conditions de la plateforme */}
                        <Col md={12} className="mt-3">
                          <Form.Group controlId="platformPolicy">
                            <Form.Check
                              checked={isPolicyAndCondidentiality}
                              size={30}
                              onChange={(e) => setisPolicyAndCondidentiality(e.target.checked)}
                              label={
                                <div className="text-white">
                                  Accepter les{" "}
                                  <a
                                    className="text-white"
                                    href={`/${ROUTES.PRIVACY_POLITICYS}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: "underline", color: "blue" }}
                                  >
                                    termes et politique
                                  </a>{" "}
                                  de la plateforme de Mareza
                                </div>
                              }
                            />
                          </Form.Group>
                        </Col>

                        {/* Conditions de l'agence */}


                        <Col md={12}>
                          <Form.Group controlId="agencyPolicy">
                            <Form.Check
                              checked={isVerifyPolicyOfAgence}
                              size={30}
                              onChange={(e) => setisVerifyPolicyOfAgence(e.target.checked)}
                              label={
                                <div className="text-white">
                                  Accepter les{" "}
                                  <a
                                    className="text-white"
                                    href={"/" + ROUTES.PRIVACY_POLITICYS_AGENCY + "?agency=" + owner?._id}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: "underline", color: "blue" }}
                                  >
                                    termes et politique
                                  </a>{" "}
                                  de l{"'"}agence de réservation
                                </div>
                              }
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )
                  }





                </Row>

                <div className="mt-5" style={{ justifyContent: "start" }}>
                  <div className="d-flex mt-4">
                    {/* Bouton Précédent */}
                    {
                      currentStep !== 1 && (
                        <div className="p-1">
                          <Button
                            type="button" className="w-100"
                            style={{
                              borderRadius: "50px", // Arrondir les coins
                              padding: "10px 20px 10px 20px", // Ajuster le padding
                              border: "1px solid #ccc", // Ajouter une bordure légère
                            }}
                            variant="light"
                            onClick={handlePreviousStep}
                            disabled={currentStep === 1} // Désactiver si on est à la première étape
                          >
                            Précédent
                          </Button>
                        </div>
                      )
                    }

                    {/* Bouton Suivant */}
                    {currentStep !== steps.length && (
                      <div className="p-1">
                        <Button
                          type="button" className="w-100"
                          style={{
                            borderRadius: "50px", // Arrondir les coins
                            padding: "10px 20px 10px 20px", // Ajuster le padding
                            border: "1px solid #ccc", // Ajouter une bordure légère
                          }}
                          variant="light"
                          onClick={handleNextStep}
                          disabled={currentStep === steps.length} // Désactiver si on est à la dernière étape
                        >
                          Suivant
                        </Button>
                      </div>
                    )}

                    {/* Bouton Réserver */}
                    {isLoading ? (
                      <Spinner variant="primary" />
                    ) : currentStep === 4 ? (
                      <div className="p-1">
                        <Button
                          type="submit" className="w-100"
                          style={{
                            borderRadius: "50px", // Arrondir les coins
                            padding: "10px 20px 10px 20px", // Ajuster le padding
                            border: "1px solid #ccc", // Ajouter une bordure légère
                            fontWeight: "bold", // Rendre le texte en gras
                          }}
                          variant="light"
                          disabled={isLoading}
                        >
                          <span className="px-2">Réserver</span> <MdArrowCircleRight className="mx-1 text-primary" size={25} />
                        </Button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

              </Form>
            </Col>

            {/* ✅ Section Prix & Réservation */}
            <Col md={3}>

            </Col>

          </div>
        </div>

        <div style={{ position: "absolute", right: "1%", bottom: -30, zIndex: 60 }}>
          <img src={Vector_Design} />
        </div>
      </div>





      {/*Liste vehicle or property */}




      {
        currentItems && currentItems.length > 0 && (
          <div className="container">
            {
              vehicle && vehicle?._id ?
                (<h3 style={{ color: "#737373" }} className="py-2">Autres véhicules populaires</h3>)
                :
                property && property?._id ? (<h3 style={{ color: "#737373" }} className="py-2">Autres Prorpiétés populaires</h3>)
                  : ""
            }
          </div>
        )
      }
      <div className="container">
        {currentItems.length > 0 && currentItems.filter((item) => item.isVisible == true).length > 0 && (
          <Carousel responsive={responsive} autoPlay={true} infinite={true} transitionDuration={8}    >
            {currentItems.length > 0 && currentItems.filter((item) => item.isVisible == true).length > 0 ? (
              currentItems.filter((item) => item.isVisible == true).map((item) => {
                // État unique pour chaque élément
                const isHovered = hoverStates[item._id]; // Vérifie si l'élément actuel est survolé
                return (
                  <div
                    onMouseEnter={() => handleMouseEnter(item._id)} // Déclenche lorsqu'on survole
                    onMouseLeave={() => handleMouseLeave(item._id)} // Déclenche lorsque la souris quitte
                    className="p-2"
                  >
                    <div className="" style={{ width: "100%" }}>
                      <div className="shadow-sm rounded-lg" style={{ margin: "10px", width: "100%", overflow: "hidden", }}>

                        <div style={{
                          height: "200px",
                          background: "#F2F2F2", width: "100%",
                          borderBottomLeftRadius: isHovered ? "20px" : "0px",
                          borderBottomRightRadius: isHovered ? "20px" : "0px",
                        }}>
                          {
                            item && item.images && item.images.length > 0 ?
                              <img src={item.images[0]} style={{
                                height: "200px", width: "100%",
                                transition: "transform 0.3s ease-in-out",
                                transform: isHovered ? "scale(1.1)" : "scale(1)", // Zoom léger sur l'image
                              }} />
                              :
                              <img src={emptyImage} style={{
                                height: "200px", width: "100%",
                                transition: "transform 0.3s ease-in-out",
                                transform: isHovered ? "scale(1.1)" : "scale(1)", // Zoom léger sur l'image
                              }} />
                          }
                        </div>
                        <div style={{ background: "white", padding: "10px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px" }}>
                          <div><h6 className="text-dark">{item.brand || item.name}</h6></div>
                          <div className="pt-2 pb-2" style={{ display: "flex", justifyContent: "space-between", }}>
                            <div>
                              <span style={{ fontWeight: "bold", fontSize: "25px" }} className="font-bold text-dark"> {item.basePricePerDay || 0} </span>
                              <span style={{ fontWeight: "bold", fontSize: "12px" }} className="text-dark">DZD</span>
                              <span style={{ color: "#A6A6A6", fontSize: "12px" }}>/Jour</span>
                            </div>
                            <div>
                              {/*<span style={{ color: "#A6A6A6", fontSize: "12px" }}> <MdLocationOn /> Algerie</span> */}
                            </div>
                          </div>
                          {// vehicle
                            item?.brand && (item?.mileage || item?.options?.automaticTransmission || item?.passenger || item?.engineType?.name) && (
                              <div style={{ padding: "5px 5px 5px 5px", display: "flex", justifyContent: "space-between", background: "#F6F6F6" }} className="my-3 rounded-lg">
                                {// kilometrage
                                  item?.mileage && (
                                    <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                      <IoSpeedometerOutline className="text-dark" size={25} />
                                      <span className="text-dark">{item?.mileage || 0}</span>
                                    </div>
                                  )
                                }
                                {// transmition
                                  (item?.options?.automaticTransmission || item?.options?.manualTransmission) && (
                                    <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                      <TbManualGearbox className="text-dark" size={25} />
                                      <span className="text-dark">
                                        {item?.options?.automaticTransmission ? "Auto" :
                                          item?.options?.manualTransmission ? "Manuelle" : ""}
                                      </span>
                                    </div>
                                  )
                                }
                                {// Sièges
                                  item?.passenger && (
                                    <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                      <MdOutlineAirlineSeatReclineNormal className="text-dark" size={25} />
                                      <span className="text-dark">{item?.passenger || 4}</span>
                                    </div>
                                  )
                                }

                                {//moteur
                                  item?.engineType && item?.engineType?.name && (
                                    <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                      <FaChargingStation className="text-dark" size={25} />
                                      <span className="text-dark">{item?.engineType?.name || ""}</span>
                                    </div>
                                  )
                                }
                              </div>
                            )
                          }

                          {// property
                            item?.name && (
                              <div style={{ padding: "5px 5px 5px 5px", display: "flex", justifyContent: "space-between", background: "#F6F6F6" }} className="my-3 rounded-lg">

                                <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "row" }}>
                                  <MdOutlineLocationOn className="text-dark" size={25} />
                                  <span className="text-dark">{item.address}</span>
                                </div>
                              </div>
                            )
                          }

                          <div>
                            <Button type="button"
                              onClick={() => {
                                if (item?.color) {
                                  dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: item });
                                  dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: {} });
                                  navigate(`/${ROUTES.CAR_DETAIL_VIEW}/${item._id}/name/${item.brand}/description/${item.brand}`);
                                } else {
                                  dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: {} });
                                  dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: item });
                                  navigate(`/${ROUTES.CAR_DETAIL_VIEW}/${item._id}/name/${item.name}/description/${item.name}`);
                                }
                              }}
                              style={{
                                padding: "10px 5px 10px 5px", borderRadius: "30px", textAlign: "center", display: "flex", justifyContent: "center"
                                , borderRadius: "30px",
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                transition: "all 0.3s ease-in-out", // Animation fluide
                              }}
                              variant={isHovered ? "dark" : "outline-dark"} // Change le variant du bouton
                              className={`w-100 ${isHovered ? "text-white" : "text-dark"} border-dark`}>
                              <div style={{ display: "flex", width: "100%", flexDirection: "row", justifyContent: isHovered ? "space-between" : "center", alignContent: "center" }}>

                                <div className={`${isHovered ? "px-3 font-fold" : "p-1"}`}>
                                  <span className="text-center "> Voir l{"'"}offre </span>
                                </div>
                                {
                                  isHovered && (
                                    <div className={`${isHovered ? "px-3 font-fold" : "p-1"}`} style={{ transition: "all 0.3s ease-in-out" }}>
                                      <FaArrowAltCircleRight size={25} className="text-primary" />
                                    </div>
                                  )
                                }
                              </div>
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (
              <Col md={12}></Col>
            )}
          </Carousel>
        )}
      </div>


    </div>
  )
}

export default ReservationFormPage;
